import { configureStore } from '@reduxjs/toolkit';
import entityTanReducer from './slice/entityTanSlice.js';
import userReducer from './slice/userSlice';
import selfServiceReducer from './slice/selfServiceSlice';


const store = configureStore({
  reducer: {
    entityTan: entityTanReducer,
    user: userReducer,
    selfService: selfServiceReducer,
  },
});

export default store;
